import {push} from "redux-first-history";
import {store} from "./configureStore";

export const navigateTo = (path: string): void => {
    store.dispatch(push(path));
};
